var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":24}},[_c('el-card',[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("申报走势")])]),_c('div',{style:({ height: '320px' }),attrs:{"id":"myChart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }